import { Snackbar, Slide } from "@mui/material";



export const SnackBar = ({side, open, action}) => {


    return  <Snackbar
            open={open}
            autoHideDuration={3000}
            message="Desfazer Operação"
            anchorOrigin={{ vertical: 'bottom', horizontal: side }}
            action={action}
            TransitionComponent={Slide}
            ContentProps={{
                sx: {
                    color:'black',
                    background: "white"
                }
            }}
        /> 
}